module.exports = __webpack_public_path__ + "static/media/office-building-large.a30ff35c.png";